<template>
    <section class="everything-layout-card">
        <div class="builder-information">
            <ds-icon name="info-circle" />

            <p>This is an non-editable system layout</p>

            <div>
                <a class="new-layout-link" @click="createLayout">Create new layout</a>

                <a class="copy-layout-link" @click="copiedLayout">Copy this layout</a>
            </div>
        </div>

        <div class="tab-content">
            <div class="slides">
                <div
                    v-for="(ls, index) in contactCustomizableLayout.layoutComponents"
                    :key="index"
                    ref="tab"
                    :class="{'tab-selected': selectedTab }"
                    class="capsule-buttons"
                >
                    <ds-text-button
                        :class="{'tab-selected': setTabSelected(ls.name)}"
                        class="tab-button"
                    >
                        {{ ls.name }}
                    </ds-text-button>
                </div>
            </div>
        </div>

        <div class="tab-names">
            {{ selectedTab }}
        </div>

        <div
            v-for="(head, hIndex) in headerList"
            :key="hIndex"
            class="header-padding"
        >
            <ds-card>
                <ds-card-header>
                    <div class="tabs-card">
                        <div class="fields-icons names-incard">
                            <div class="head-name">
                                {{ head.name }}
                            </div>

                            <span v-if="head.components != null" class="field-names-text"> ({{ head.components.length }} fields)
                            </span>
                        </div>

                        <div class="moreOptions">
                            <span class="chevron-header" @click="toggleHeaderMoreOptions(head.name)">
                                <ds-icon :name="(head.name !== moreOptionHeaderName ? moreMap.get(head.name) : moreOptions) ? 'chevron-up' : 'chevron-down'" />
                            </span>
                        </div>
                    </div>
                </ds-card-header>

                <ds-card-body v-if="head.name !== moreOptionHeaderName ? moreMap.get(head.name) : moreOptions">
                    <div
                        v-for="(fieldNames, fIndex) in head.components"
                        :key="fIndex"
                        class="fields-incard"
                    >
                        <span>
                            {{ fieldNames.name }}
                        </span>

                        <span class="field-names-text">(System field:{{ fieldNames.name }})
                        </span>
                    </div>
                </ds-card-body>
            </ds-card>
        </div>
    </section>
</template>

<script>

export default {
    props: {
        userId: [String, Number],
        contactCustomizableLayoutObj: Object,
    },

    data() {
        return {
            selectedTab: 'Contact Info',
            contactCustomizableLayout: {},
            moreOptionHeaderName: new Map(),
            moreMap: new Map(),
            moreOptions: true,
            customFields: [],
            tabIndex: 0,
            headerList: [],
        };
    },
    created() {
        this.contactCustomizableLayout = this.contactCustomizableLayoutObj;
        this.headerList = this.contactCustomizableLayout.layoutComponents && this.contactCustomizableLayout.layoutComponents[this.tabIndex].components
            ? this.contactCustomizableLayout.layoutComponents[this.tabIndex].components : [];
    },
    mounted() {
        this.$root.$on('EVERTHING_LAYOUT_DISPLAY_DETAILS', (data) => {
            this.contactCustomizableLayout = data;
        });
    },

    methods: {
        getFieldsLength(header) {
            return header.length;
        },

        setTabSelected(tabName) {
            return this.selectedTab === tabName;
        },

        createLayout() {
            this.$root.$emit('BUTTON_ADD_LAYOUT', true);
        },

        copiedLayout() {
            this.$root.$emit('COPY_EVERYTHING_LAYOUT', this.contactCustomizableLayout);
        },

        toggleHeaderMoreOptions(moreOptionValue) {
            this.moreOptionHeaderName = moreOptionValue;

            if (this.moreMap.has(moreOptionValue)) {
                this.moreMap.set(moreOptionValue, !this.moreMap.get(moreOptionValue));
            } else {
                this.moreMap.set(moreOptionValue, true);
            }
            this.moreOptions = this.moreMap.get(moreOptionValue);
        },
    },
};
</script>

<style lang="scss" scoped>
.copy-layout-link {
    color: white;
    margin-left: $spacing-200;
    font-weight: bold;
}

.new-layout-link {
    color: white;
    padding-left: 5rem;
    font-weight: bold;
}

.tab-button {
    margin: $spacing-075 0;
    padding: 0 $spacing-200;
    height: 1.8rem;
    display: inline-flex;
    align-items: center;
    font-size: small;
    color: $color-text;
    text-align: center;
    text-decoration: none;
    white-space: nowrap;
    background-color: $color-gray-20;
    border: none;
    border-radius: 1.8rem;

    &:hover,
    &:active {
        color: $color-text;
        background-color: $color-gray-20;
    }

    &:focus {
        outline: 0;
    }
}

.capsule-buttons {
    margin: $spacing-075 $spacing-025;
    height: 1.75rem;
    display: inline-flex;
    align-items: center;
    font-size: small;
    color: $color-text;
    text-align: center;
    text-decoration: none;
    white-space: nowrap;
    background-color: $color-gray-20;
    border: none;
    border-radius: 1.75rem;
}

.tab-content {
    padding: $spacing-200;
    display: flex;
    overflow-y: hidden;
}

.slides {
    display: flex;
    flex-flow: row wrap;
    @include padding-start($spacing-050);

    > div {
        @include margin-end($spacing-100);
    }
}

.tab-selected {
    background-color: $color-white;
    box-shadow: $drop-shadow-z2;
}

.fields-icons {
    display: inline-flex;
}

.chevron-header {
    margin-top: 0.625rem;
}

.names-incard {
    height:  3.5rem;
    padding: $spacing-100 $spacing-200 $spacing-100 $spacing-300;
    background-color: $color-white;
    font-size: $font-size-md;
}

.fields-incard {
    height: 3.5rem;
    padding: $spacing-100 $spacing-200 $spacing-100 $spacing-300;
    background-color: $color-white;
}

.moreOptions {
    margin-right: $spacing-200;
    display: flex;
    float: right;
}

.tab-names {
    font-size: $font-size-lg;
    font-weight: 300;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.2;
    letter-spacing: normal;
    padding: 10px;
}

.builder-information {
    background-color: $color-navy;
    padding: $spacing-200;
    color: $color-white;
    display: flex;
    grid-template-columns: 1.5rem auto;
    grid-template-rows: minmax(1.5rem, auto);
    grid-gap: $spacing-200;
    justify-items: stretch;
    margin-bottom: $spacing-200;

    p {
        font-size: $font-size-md;
        line-height: $line-height-lg;
        font-size: $font-size-md;
        margin: 0;
    }
}

.field-names-text {
    color: $color-gray-light;
    font-size: 0.869rem;
    font-weight: normal;
}

.header-padding {
    padding: 0.8rem;
}

.everything-layout-card {
    padding-left: $spacing-500;
    padding-top: $spacing-300;
}

.head-name {
    margin-right: px-to-rem(5px);
}

@media screen and ($small) {
    .record {
        margin: 0 ($spacing-300 * -1);
    }

    .slides {
        flex-flow: row nowrap;
        overflow-x: auto;
        padding: 0 $spacing-300;
    }

    .slides::-webkit-scrollbar {
        display: none;
    }
}

@media screen and ($medium) {
    .slides {
        display: flex;
        overflow: auto;
    }

    ::-webkit-scrollbar {
        width: 0;
        background: transparent;
    }
}
</style>
